import { render, staticRenderFns } from "./CustomersProducts.vue?vue&type=template&id=b63dfd50&"
import script from "./CustomersProducts.vue?vue&type=script&lang=js&"
export * from "./CustomersProducts.vue?vue&type=script&lang=js&"
import style0 from "./CustomersProducts.vue?vue&type=style&index=0&id=b63dfd50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports